import { get } from 'lodash-es';

const byNoResults = (state: any) => get(state, 'resultList.totalHits') === 0;

export default byNoResults;
